import { render, staticRenderFns } from "./SignupStep.vue?vue&type=template&id=008888b4&"
import script from "./SignupStep.vue?vue&type=script&lang=js&"
export * from "./SignupStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports